<template>
  <div :class="$style.vipPreferencesCardBlock">
    <img :src="preference.icon.url" />
    <span :class="$style.vipPreferencesCardBlockTitle">{{ preference.title }}</span>
    <span :class="$style.vipPreferencesCardBlockDescription">
      {{ snippet.format(preference.description) }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { TVipPreference } from '~/types/infoPages';

defineProps({
  preference: {
    type: Object as PropType<TVipPreference>,
    required: true,
  },
});

const snippet = useSnippet();
</script>

<style lang="scss" module src="./preferenceCard.scss"></style>
